import type { FC, PropsWithChildren } from 'react';
import React from 'react';

const ReduxTranslationsContextProvider: FC<PropsWithChildren> = ({ children }) => <>{children}</>;

export default ReduxTranslationsContextProvider;
